export default {"src":"/uk/_next/static/media/actionsIconGrey.f3d6d76a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};